var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.697 3.158V.797H11V0H0v.797h1.303v2.36c0 .963.459 1.85 1.243 2.407l2.28 1.578-2.28 1.594a2.952 2.952 0 00-1.243 2.406v2.361H0v.797h11v-.797H9.697v-2.376c0-.962-.459-1.85-1.243-2.406L6.188 7.142l2.28-1.593a2.93 2.93 0 001.23-2.391zm-7.61 0V.797h6.826v2.36c0 .632-.282 1.219-.74 1.625h-5.33a2.136 2.136 0 01-.756-1.624zm5.937 6.225c.563.39.903 1.053.903 1.744v2.045l-2.901-2.947a.752.752 0 00-1.052 0l-2.887 2.947v-2.045c0-.692.341-1.353.904-1.744l2.516-1.76 2.517 1.76z",
    fill: "#515864"
  })));
}
export default SvgSandWatch;